module.exports = "/_next/static/images/7378f834c21e7643b6d73646c94f71c2-insurance-life-marketing-link.jpg";